import React from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Mail, MapPin } from 'lucide-react';
export function ContactPage() {
  return <>
      {/* Hero Section */}
      <Section className="py-20" background="offwhite" data-id="element-324">
        <div className="text-center mb-12" data-id="element-325">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-326">
            Contact Us
          </h1>
          <p className="text-xl font-inter text-neutral-charcoal max-w-3xl mx-auto" data-id="element-327">
            Get in touch with our team. We'd love to hear from you.
          </p>
        </div>
      </Section>

      {/* Contact Info & Form */}
      <Section background="white" data-id="element-328">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-329">
          {/* Contact Information */}
          <div data-id="element-330">
            <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-8" data-id="element-331">
              Get In Touch
            </h2>
            <div className="space-y-6" data-id="element-332">
              <div className="flex gap-4" data-id="element-333">
                <div className="flex-shrink-0" data-id="element-334">
                  <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-335">
                    <Mail size={24} className="text-white" data-id="element-336" />
                  </div>
                </div>
                <div data-id="element-337">
                  <h3 className="font-playfair font-bold text-xl text-primary-deep-blue mb-2" data-id="element-338">
                    Email
                  </h3>
                  <div className="space-y-1" data-id="element-339">
                    <div data-id="element-340">
                      <a href="mailto:natasha.farashamed@gmail.com" className="font-inter text-primary-royal-blue hover:underline block" data-id="element-341">
                        natasha.farashamed@gmail.com
                      </a>
                    </div>
                    <div data-id="element-342">
                      <a href="mailto:nicole.farashamed@gmail.com" className="font-inter text-primary-royal-blue hover:underline block" data-id="element-343">
                        nicole.farashamed@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-344">
                <div className="flex-shrink-0" data-id="element-345">
                  <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-346">
                    <MapPin size={24} className="text-white" data-id="element-347" />
                  </div>
                </div>
                <div data-id="element-348">
                  <h3 className="font-playfair font-bold text-xl text-primary-deep-blue mb-2" data-id="element-349">
                    Location
                  </h3>
                  <p className="font-inter text-neutral-charcoal" data-id="element-350">
                    Los Angeles, California
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-neutral-offwhite p-8 rounded-xl" data-id="element-351">
            <h2 className="text-2xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-352">
              Send Us a Message
            </h2>
            <form className="space-y-4" data-id="element-353">
              <div data-id="element-354">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-355">
                  Name *
                </label>
                <input type="text" required className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="Your name" data-id="element-356" />
              </div>
              <div data-id="element-357">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-358">
                  Email *
                </label>
                <input type="email" required className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="your@email.com" data-id="element-359" />
              </div>
              <div data-id="element-360">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-361">
                  Subject *
                </label>
                <input type="text" required className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="How can we help?" data-id="element-362" />
              </div>
              <div data-id="element-363">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-364">
                  Message *
                </label>
                <textarea required rows={6} className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="Your message..." data-id="element-365" />
              </div>
              <Button type="submit" className="w-full" data-id="element-366">
                Send Message
              </Button>
            </form>
          </div>
        </div>
      </Section>

      {/* Additional Info */}
      <Section background="sand" data-id="element-367">
        <div className="text-center max-w-3xl mx-auto" data-id="element-368">
          <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-369">
            We're Here to Help
          </h2>
          <p className="text-lg font-inter text-neutral-charcoal" data-id="element-370">
            Whether you're interested in donating, volunteering, partnering with
            us, or just want to learn more about our work, we'd love to hear
            from you. We typically respond within 1-2 business days.
          </p>
        </div>
      </Section>
    </>;
}